import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { TeamCard } from "@/components/team-card";

export const Route = createFileRoute("/_authed/team")({
  component: TeamPage,
});

function TeamPage() {
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Account" title="Team" />
      <TeamCard />
    </div>
  );
}
